import { CanActivateFn, Router, ActivatedRouteSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { SessionService } from '@services/session.service';
import { GAME_ROUTING_CONFIG } from '@shared/consts/game.consts';
import { GameType } from '@shared/types/game-type';
import { combineLatest } from 'rxjs';
import { map } from 'rxjs/operators';

export const checkPermissionGuard: CanActivateFn = (
  route: ActivatedRouteSnapshot,
) => {
  const permissions = route?.data?.['permission'] as string[];
  if (!permissions?.length) return true;
  const session = inject(SessionService);
  const router = inject(Router);
  return combineLatest([session.gameType$, session.getUserRole()]).pipe(
    map(([gameType, role]) => {
      if (permissions.includes(role!)) {
        return true;
      }
      router.navigate([GAME_ROUTING_CONFIG[gameType || GameType.QUIZ]]);
      return false;
    }),
  );
};
